import React from "react"
import {createStyles, makeStyles} from "@material-ui/core"
import {AvantColors} from "../../../../styles/AvantColors"
import {
    APT_PRODUCT_ID,
    BANNER_MESSAGE,
    PLACE_PRODUCT_ID,
    STAMP_4S_PRODUCT_ID,
    STAMP_4SE_PRODUCT_ID
} from "../../../../util/Constants"

const useStyles = makeStyles(() =>
    createStyles({
        banner: {
            alignItems: "center",
            backgroundColor: AvantColors.PRIMARY_BLUE,
            color: "#FFF",
            display: "flex",
            height: "50px",
            justifyContent: "center",
            position: "fixed",
            width: "100%",
            zIndex: 1
        },
        bannerLink: {
            color: "#FFF",
            fontWeight: 700,
            marginBottom: "1px",
            marginLeft: "5px",
            textDecoration: "underline",
            '&:hover': {
                color: AvantColors.avantOrange
            }
        }
    })
)

export const ClassicReportsBanner: React.FC<{productId: number | null}> = ({productId}) => {
    const classes = useStyles()
    let strutsLink = ""

    switch(productId) {
        case STAMP_4S_PRODUCT_ID.value():
            strutsLink = "https://stamp4s-report.avantassessment.com/"
            break

        case STAMP_4SE_PRODUCT_ID.value():
            strutsLink = "https://stamp4se-report.avantassessment.com/"
            break

        case APT_PRODUCT_ID.value():
            strutsLink = "https://apt-report.avantassessment.com"
            break

        case PLACE_PRODUCT_ID.value():
            strutsLink = "https://placement-report.avantassessment.com/"
            break
    }

    return (
        <div className={classes.banner}>
            {BANNER_MESSAGE} <a href={strutsLink} className={classes.bannerLink} target={"_blank"}>Here.</a>
        </div>
    )
}